import { FC } from 'react'
import { useListView } from '../core/ListViewProvider'
import { useQueryResponse } from '../core/QueryResponseProvider'

type Props = {
    user?: any
}

const IsccuViewImageForm: FC<Props> = ({ user = {} }) => {
    const { setItemIdForUpdate } = useListView()
    const { refetch } = useQueryResponse()

    const cancel = (withRefresh?: boolean) => {
        if (withRefresh) {
            refetch()
        }
        setItemIdForUpdate(undefined)
    }

    return (
        <>
            {user?.selfDeclarationDoc?.docUrl && (
                <div style={{
                    height: '100%',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    {/* Header with title */}
                    <div style={{
                        padding: '20px 20px 10px 20px',
                        borderBottom: '1px solid #eee',
                        backgroundColor: 'white'
                    }}>
                        <h3 style={{
                            margin: '0',
                            fontSize: '18px',
                            fontWeight: '600',
                            color: '#333'
                        }}>
                            Self Declaration
                        </h3>
                    </div>

                    {/* PDF Content */}
                    <div style={{
                        flex: '1',
                        overflow: 'hidden',
                        padding: '20px'
                    }}>
                        <iframe
                            src={`${user.selfDeclarationDoc.docUrl}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
                            style={{
                                width: '100%',
                                height: '100%',
                                border: 'none',
                                overflow: 'hidden'
                            }}
                            title="Self Declaration Document"
                            scrolling="no"
                        />
                    </div>
                </div>
            )}
        </>
    )
}

export default IsccuViewImageForm